import React from 'react';

import { defineMessages } from 'src/i18n';
import { useISIntl } from 'src/i18n/utils';
import { AppStore } from 'src/stores/AppStore';
import { injectStore } from 'src/util/injectStore';
import { navFreeTrial } from 'src/util/navigation';
import { URLQueryParamKeys } from 'src/util/url';

const messages = defineMessages({
  title: {
    id: 'invoicePDFButton.title',
    defaultMessage: 'download a PDF copy of the {docType} to your device'
  },
  label: {
    id: 'invoicePDFButton.label',
    defaultMessage: 'download PDF'
  }
});

interface Prop extends React.HTMLProps<HTMLButtonElement> {
  store: AppStore;
}

export const InvoicePDF = (props: Prop) => {
  const invoice = props.store.doc;
  const { ft } = useISIntl();
  const onDownloadButtonClick = () => {
    if (invoice.user.isSubActive) {
      invoice.download();
    } else {
      navFreeTrial({ user: invoice.user, ref: URLQueryParamKeys.DOCUMENT_ACTIONS });
    }
  };

  return (
    <>
      <button
        disabled={props.store.isLoading}
        title={ft(messages.title)}
        className={`btn btn-download ${props.className ? props.className : ''}`}
        onClick={onDownloadButtonClick}>
        <span>{props.value || ft(messages.label)}</span>
      </button>
    </>
  );
};

export default injectStore(InvoicePDF);
